import { KTSVG } from '@ospace/shared'

import { showNotification } from '@ospace/shared/components/Notification'

export const CopyToClipboardBtn = (props: { text: string; message?: string }) => {
  return (
    <button
      className='btn btn-link btn-sm'
      onClick={() =>
        navigator.clipboard.writeText(props.text).then(() => {
          showNotification({
            message: props.message || 'Program ID copied to the clipboard.',
            type: 'success',
          })
        })
      }
    >
      <KTSVG
        style={{ position: 'relative', bottom: '0.125em' }}
        path='/media/icons/duotune/general/gen054.svg'
      />
    </button>
  )
}
